export default __webpack_public_path__ + "static/media/tuan-tran.0ff82cc3.jpg";